import { render } from "./DetailsNote.vue?vue&type=template&id=6a5036fd&ts=true"
import script from "./DetailsNote.vue?vue&type=script&lang=ts"
export * from "./DetailsNote.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__